import { logEvent, logInteractionEvent } from "../../../utils/appInsight";
import { isModuleFinished, isSectionFinished } from "../../../utils/helpers";
import { userCompletesSectionThunk } from "../../../store/thunks";

export default (topic, finishedTopics, allTopics, section, dispatch) => {
  const allFinishedTopics = [...finishedTopics, topic.contentKey];
  if (isModuleFinished(allFinishedTopics, topic.parentContentId, allTopics)) {
    logEvent({
      name: "ModuleCompleted",
      properties: {
        section,
        moduleKey: topic.parentContentId,
        topicKey: topic.contentKey,
      },
    });
    logInteractionEvent("ModuleCompleted", {
      section,
      moduleKey: topic.parentContentId,
    });

    if (isSectionFinished(allFinishedTopics, allTopics, section)) {
      dispatch(userCompletesSectionThunk(section));
    }
  }

  logEvent({
    name: "ActivityCompleted",
    properties: {
      section,
      moduleKey: topic.parentContentId,
      topicKey: topic.contentKey,
      activityKey: topic.data.activity.activityKey,
    },
  });

  logInteractionEvent("ActivityCompleted", {
    section,
    topicKey: topic.contentKey,
    activityKey: topic.data.activity.activityKey,
  });
};
